// Early shims for legacy services to prevent null/undefined errors during init
// This runs immediately to provide safe fallbacks before full bootstrap
(function() {
  'use strict';
  
  console.log('🔧 [Early Shims] Initializing safe placeholders for services');
  
  // All shims removed - bootstrap/services.js handles initialization and legacy globals properly
  // This ensures no placeholder warnings and real service delegation from the start

  // Expose SHOPIFY_AVAILABLE_SIZES early to prevent emergency fallback issues in tests and legacy code
  window.SHOPIFY_AVAILABLE_SIZES = {
    polos_knits: [
      "YXXXS", "YXXS", "YXS", "YS", "YM", "YL", "YXL", "XS", "S", "M", "L", "XL", "XXL"
    ],
    outerwear_fleece: [
      "YXXS", "YXS", "YS", "YM", "YL", "YXL", "S", "M", "L", "XL"
    ],
    active_bottoms: [
      "YXXS", "YXS", "YS", "YM", "YL", "YXL", "S", "M", "L", "XL"
    ],
    active_tops: [
      "YXXS", "YXS", "YS", "YM", "YL", "YXL", "S", "M", "L", "XL"
    ],
    sweaters: [
      "YXXS", "YXS", "YS", "YM", "YL", "YXL", "S", "M", "L", "XL"
    ],
    pull_on_pants_shorts: [
      "YXXS", "YXS", "YS", "YM", "YL", "YXL"
    ],
    girls_blouses: [
      "YXXS", "YXS", "YS", "YM", "YL", "YXL"
    ],
    girls_jumper: [
      "3", "4", "5", "6", "6H", "6X", "7", "7H", "8", "8H", "9H", "10", "10H", "12"
    ],
    girls_skorts: [
      "3", "4", "5", "6", "6X", "7", "8", "10", "12"
    ],
    boys_pants_shorts: [
      "3", "4", "5", "6", "6X", "7", "8", "10", "12", "14", "16", "18"
    ],
    girls_pants_shorts: [
      "3", "4", "5", "6", "6X", "7", "8", "10", "12", "14"
    ]
  };
  window.getAvailableSizes = function(category) {
    const normalizedCategory = String(category || '').toLowerCase().trim();
    return window.SHOPIFY_AVAILABLE_SIZES[normalizedCategory] || [];
  };

  console.log('✅ [Early Shims] Exposed SHOPIFY_AVAILABLE_SIZES and getAvailableSizes to window for early availability');

  // Make tests fail fast on console errors (tests set window.__PLAYWRIGHT_TEST__ = true in global-setup)
  if (window.__PLAYWRIGHT_TEST__) {
    const originalError = console.error.bind(console.error);
    const originalWarn = console.warn.bind(console.warn);
    console.error = function(...args) {
      originalError(...args);
      // Fail fast only on critical errors, not shims (but shims are removed now)
      if (args[0] && typeof args[0] === 'string' && (args[0].includes('ERROR') || args[0].includes('Failed'))) {
        throw new Error(`Test failed fast due to console.error: ${args.join(' ')}`);
      }
    };
    console.warn = function(...args) {
      // Suppress non-critical warnings in tests if needed, but log them
      originalWarn(...args);
    };
    console.log('✅ [Early Shims] Installed console.error listener for test environment to fail fast on errors');
  }

  console.log('✅ [Early Shims] Initialization complete (all shims removed, sizes exposed, test listener ready if applicable)');
})();